interface SmartlookFunction {
  (...args: any[]): void;
  api?: any[];
}

declare global {
  interface Window {
    smartlook: SmartlookFunction;
  }
}
export const initSmartlook = (projectKey: string) => {
  if (typeof window !== "undefined") {
    (function (d) {
      const o = (window.smartlook = function (...args: any[]) {
        o.api!.push(args);
      } as SmartlookFunction);
      const h = d.getElementsByTagName("head")[0];
      const c = d.createElement("script");
      o.api = [];
      c.async = true;
      c.type = "text/javascript";
      c.charset = "utf-8";
      c.src = "https://web-sdk.smartlook.com/recorder.js";
      h.appendChild(c);
    })(document);

    window.smartlook("init", projectKey, {
      region: "eu",
    });
  }
};
